var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default"),_vm._v("\n    "+_vm._s(_vm._f("currency")(_vm.internalPrice))+"\n    "),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }